module.exports = __webpack_public_path__ + "img/block-2.1aa82785.svg";